<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import tabsView from '@/components/tabsView/index.vue'
import orderDetails from './orderDetails.vue'
import { useRouter } from 'vue-router'
import { onMounted, ref, reactive } from 'vue'
import topUpView from '@/components/topUpView/index.vue'
import { useUserStore } from '@/stores/userStore'

import { setWithdrawAPI, getWithdrawListAPI, getRebatesLogsAPI, setCancelBankAPI, getModifyBankOrderAPI, getOrderDetailAPI, getConfigAPI, getExchangeRateAPI } from '@/apis/wallet'
import { getPromoterAPI, getMemberListAPI } from '@/apis/user'
import Prompt from './Prompt.vue'
import { useI18n } from 'vue-i18n'
import { formatToLocalTime, exchangeRateUSD, symbolStatus, formatToLocalTimeYMD, RateUSD, exchangeRate } from '@/utils/index'
const { t, locale } = useI18n();
const router = useRouter()
const userStore = useUserStore()
const dialogVisible = ref(false)
const PromptModel = ref(false)
const orderSn = ref();
const faqIndex = ref(0);
const ipTime = userStore.ipTime;
const handleClose = (value, type, id) => {
    console.log(id)
    dialogVisible.value = false
    data.createOrder = {}
    if (type == 1) {
        orderSn.value = id
        PromptModel.value = true
    }
    userStore.getUser()

}
const Close = () => {
    PromptModel.value = false
    data.MemberFrom.page = 1
    getMemberList()
}

const data = reactive({
    info: {
        url: '',
        code: '',
        member_count: '',
        ratio: '',
        total_reward: '',
    },
    MemberFrom: {
        // order_no: '',
        // bank_name: '',
        // start_time: '',
        // end_time: '',
        // status: '',//:0 未支付,1 已支付,2 已收货
        // bank_status: null,
        page: 1,
        page_size: 5
    },
    config: {
        user_withdraw_ratio: null, //用户提现手续费
        user_withdraw_min: null,//用户提现最低金额
    },
    exchangeRate: [],
    total: 0,
    setStatueFrom: {
        order_no: null,
        status: null
    },
    statusAll: [
        { label: t('number31'), value: 1 },
        { label: t('number32'), value: 2 },
        { label: t('number33'), value: 3 },
        { label: t('number34'), value: 4 },
    ],
    orderDetail: {},
    WithdrawList: [],
    WithdraFrom: {
        status: "",
        page: 1,
        page_size: 10
    },
    withdraTotal: 0,
    withdraStatus: [{ label: t('number35'), value: 1 },
    { label: t('number36'), value: 2 },
    { label: t('number37'), value: 3 },],
    withdrawalFrom: {
        amount: null,
        currency: "",
    },
    withdrawalAmount: 0,//实际到账
    checkexchangeRate: {
        change: null,
        currency: "",
        rate: null,
        symbol: ""
    },
    usdData: {},
    WithdrawalData: {},
    rebatesTotal: 0,
    rebatesLogs: {
        is_invalid: "",
        is_used: "",
        page: 1,
        page_size: 10
    },
    rebatesList: [],
    isInvalidData: [
        { label: t('setup87'), value: 1 },
        { label: t('setup88'), value: 2 },
    ],
    isUsedALL: [
        { label: t('setup89'), value: 1 },
        { label: t('setup90'), value: 2 },
        { label: t('setup91'), value: 3 },
    ]
})

const WithdraStatus = (state) => {
    const stateMap = {
        1: t('number35'),
        2: t('number36'),
        3: t('number37'),
    }
    return stateMap[state]
}
const fomartState = (state) => {
    const stateMap = {
        1: t('number31'),//待审核
        2: t('number32'),//通过
        3: t('number38'),//驳回
        4: t('number34')
    }
    return stateMap[state]
}
const isInvalidStatus = (state) => {
    const stateMap = {
        1: t('setup87'),
        2: t('setup88'),
    }
    return stateMap[state]
}
const isUsedStatus = (state) => {
    const stateMap = {
        1: t('setup89'),
        2: t('setup90'),
        3: t('setup91'),
    }
    return stateMap[state]
}
const isMobile = ref(false);//false代表pc
onMounted(() => {

    getExchangeRate()
    getConfig()
    getMemberList()
    userStore.getUser()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);



})
/**
 * 获取订单列表
 */
const orderList = ref([])
const getMemberList = async () => {
    const res = await getMemberListAPI(data.MemberFrom)
    if (res.code == 0) {
        orderList.value = res.data.list,
            data.total = res.data.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const loading = ref(false)
const noMore = computed(() => {
    if (orderList.value) {
        if (orderList.value.length >= data.total) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {
    loading.value = true
    setTimeout(async () => {
        data.MemberFrom.page++
        const res = await getMemberListAPI(data.MemberFrom)
        if (res.data.list) {
            orderList.value = [...orderList.value, ...res.data.list]
            loading.value = false
        }
    }, 100)
}


// 页数切换
const pageChange = (page) => {
    console.log(page);
    data.MemberFrom.page = page
    getMemberList()
}


/**
 * 
 * @param id 修改钱庄订单
 * @param type 
 */
const setState = async (id, type) => {
    data.setStatueFrom.order_no = id
    data.setStatueFrom.status = type
    const res = await getModifyBankOrderAPI(data.setStatueFrom)
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number39') })
        getMemberList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const statusClose = async (id) => {
    const res = await setCancelBankAPI({ order_no: id })
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number40') });
        getMemberList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

/**
 * 
 * @param id 获取订单详情
 */
const walletDetails = ref(false)
const getOrderDetail = async (id) => {
    const res = await getOrderDetailAPI({ order_no: id })
    if (res.code == 0) {
        walletDetails.value = true
        data.orderDetail = res.data
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const DetailsClose = () => {
    walletDetails.value = false
    data.orderDetail = {}
}
const getList = () => {
    getMemberList()
    dialogVisible.value = true
}
const activeName = ref(1)

/**
 * 获取配置
 */

const getConfig = async () => {
    const res = await getPromoterAPI()
    if (res.code == 0) {
        console.log('res.data', res.data)
        data.info = res.data
        data.info.url = window?.location.host + '/login?' + res.data.code
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const checkCurrency = ref()
/**
 * 获取汇率
 */
const getExchangeRate = async () => {
    const res = await getExchangeRateAPI()
    if (res.code == 0) {
        data.exchangeRate = res.data
        checkCurrency.value = userStore.exchangeRate.currency
        console.log('checkCurrency.value', checkCurrency.value)
        // console.log('汇率====',userStore.exchangeRate)
        // data.checkexchangeRate=userStore.exchangeRate
        // data.checkexchangeRate.change=data.exchangeRate[1].change;
        data.withdrawalFrom.currency = checkCurrency.value
        data.usdData = res.data.USD;
        console.log('data.usdData', data.usdData)
        changeCurrency(data.withdrawalFrom.currency)
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const changeCurrency = (value) => {
    // const findCurrency = data.exchangeRate.find(item => item.currency === value);
    // console.log(findCurrency)
    // data.checkexchangeRate=findCurrency
    // data.checkexchangeRate.change=data.exchangeRate[1].change;
    data.withdrawalFrom.amount = 0
    rete.value = RateUSD(value, data.usdData)
}

watch(() => data.withdrawalFrom.amount, (newValue, oldValue) => {
    console.log('值从', oldValue, '变为', newValue);

    data.withdrawalAmount = Number((newValue - newValue * (data.config.user_withdraw_ratio / 100)).toFixed(3).slice(0, -1))

}, { immediate: true });
/**
 * 提现
 */
const dialogWithdrawal = ref(false);
const amount = ref()
const WithdrawalClose = () => {
    dialogWithdrawal.value = false
    data.withdrawalFrom = {}
    // data.checkexchangeRate.change=data.exchangeRate[1].change;
    data.withdrawalFrom.currency = checkCurrency.value
    // data.withdrawalAmount=0
    tabChange(2)
}

const setWithdraw = async (row) => {
    getPromoterAPI
    const res = await setWithdrawAPI(row)
    if (res.code == 0) {
        WithdrawalClose()
        userStore.getUser()
        ElMessage({ type: 'success', message: t('number41') });
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

const tabChange = (type) => {
    console.log(type)
    if (type == 2) {
        data.WithdraFrom.page = 1
        activeName.value = type
        getWithdrawList()
    } else if (type == 3) {
        data.rebatesLogs.page = 1
        activeName.value = type
        getRebatesLogs()
    } else {
        data.MemberFrom.page = 1
        activeName.value = type
        getMemberList()
    }
}
const withdraPageChange = (page) => {

    data.WithdraFrom.page = page
    getWithdrawList()
}
/**
 * 获取提现列表
 */
const getWithdrawList = async () => {

    const res = await getWithdrawListAPI(data.WithdraFrom)
    if (res.code == 0) {
        data.WithdrawList = res.data.list,
            data.withdraTotal = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const loadings = ref(false)
const noMores = computed(() => {

    if (data.WithdrawList) {
        if (data.WithdrawList.length >= data.withdraTotal) {
            return true;
        } else {
            return false;
        }
    }
})
const disableds = computed(() => loadings.value || noMores.value)
const loads = () => {
    loadings.value = true
    setTimeout(async () => {
        data.WithdraFrom.page++
        const res = await getWithdrawListAPI(data.WithdraFrom)
        if (res.data.list) {
            data.WithdrawList = [...data.WithdrawList, ...res.data.list]
            loadings.value = false
        }
    }, 100)
}

/**
 * 提现详情
 */
const WithdrawalDetails = ref(false)
const getWithdrawalDetail = (row) => {
    data.WithdrawalData = row
    WithdrawalDetails.value = true
}
/**
 * 关闭提现详情
 */
const WithdrawalDrawerClose = () => {
    WithdrawalDetails.value = false
}
/**
 * 分红
 */
const getRebatesLogs = async () => {
    const res = await getRebatesLogsAPI(data.rebatesLogs)
    if (res.code == 0) {
        data.rebatesList = res.data.list,
            data.rebatesTotal = res.data.page.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const Logsloading = ref(false)
const LogsnoMores = computed(() => {

    if (data.rebatesList) {
        if (data.rebatesList.length >= data.rebatesTotal) {
            return true;
        } else {
            return false;
        }
    }
})
const Logsdisableds = computed(() => Logsloading.value || LogsnoMores.value)
const Logsloads = () => {
    Logsloading.value = true
    setTimeout(async () => {
        data.rebatesLogs.page++
        const res = await getRebatesLogsAPI(data.rebatesLogs)
        console.log(res)
        if (res.data.list) {
            data.rebatesList = [...data.rebatesList, ...res.data.list]
            Logsloading.value = false
        }
    }, 100)
}
const LogsPageChange = (page) => {
    console.log(page);
    data.rebatesLogs.page = page
    getRebatesLogs()
}
/**
 * 提现详情
 */
const RebatesLogsDetails = ref(false)
const getRebatesLogsDetail = (row) => {
    data.RebatesLogsData = row
    RebatesLogsDetails.value = true
}
/**
 * 关闭提现详情
 */
const RebatesLogsDrawerClose = () => {
    RebatesLogsDetails.value = false
}
const rete = ref()
// tab列表
const tabTypes = [
    { id: 1, name: t('number44') },
    { id: 2, name: t('number62') },
    { id: 3, name: t('setup84') },
]
const customheaderrow = () => {
    return {
        backgroundColor: '#F3F6F8',
        fontFamily: 'MicrosoftYaHei',
        fontSize: '14px',
        color: '#11192D',
        lineHeight: '14px',
        padding: '21px 0',
    }
}
const rowbackground = () => {
    return {
        backgroundColor: '#F3F6F8',

    }
}
const copyUrl = () => {
    try {
        const textarea = document.createElement('textarea');
        textarea.value = data.info.url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        ElMessage({ type: 'success', message: 'success' })
    } catch (error) {
        ElMessage({ type: 'error', message: error })
    }


}

</script>

<template>
    <TitleComponent :title="t('setup631')" v-if="isMobile == true"></TitleComponent>
    <div class="walletPage">


        <img class="banner" src="../../../assets/images/affiliate-banner.jpg" alt="" srcset="">
        <!-- <img class="banner" src="../../../assets/images/bannerabannera.jpg" alt="" srcset=""> -->
        <div class="step">
            <div class="icon">1
                <div class="icon-text">{{ $t('setup632') }}</div>
            </div>
            <div class="line"></div>
            <div class="icon">2 <div class="icon-text">{{ $t('setup633') }}</div>
            </div>
            <div class="line"></div>
            <div class="icon">3 <div class="icon-text">{{ $t('setup634') }}</div>
            </div>
        </div>
        <div class="phone-share">
            <div class="share-input">
                <div class="url">
                    {{ data.info.url }}
                    <!-- https://www.51shopy.com/login?{{ data.info.code }} -->
                    <!-- https://cnfans.com/my-account/affiliate/dashboard -->
                </div>
                <div class="copy-icon" @click="copyUrl">
                    {{ $t('setup636') }}
                </div>
            </div>

            <div class="share-tip">{{ $t('setup635') }}</div>
        </div>
        <div class="dividing-line"></div>
        <div class="header pc">
            <div>{{ $t('setup637') }}</div>
        </div>
        <div class="amount-info">
            <div class="info-l">
                <div>
                    ${{ data.info.total_reward }}
                    <!-- {{ exchangeRate(2, userStore.exchangeRate.symbol,
                        userStore.exchangeRate.rate)}} -->
                </div>
                <div>{{ $t('setup652') }}</div>
                <div>
                    <!-- <el-button type="primary" plain> {{ $t('setup638') }}</el-button>
                    <el-button type="primary"> {{ $t('setup639') }}</el-button> -->
                    <el-button v-if="isMobile" class="btn" type="primary" @click="router.push('/wallet')" style="width: 80%;background-color: #a3381b;">{{ $t('setup654') }}</el-button>
                    <el-button v-else class="btn" type="primary" @click="router.push('/member/wallet')" style="width: 80%;background-color: #a3381b;">{{ $t('setup654') }}</el-button>
                </div>
            </div>
            <div class="info-r">
                <div>
                    <div @click="getList">
                        <div>{{ data.info.member_count }}</div>
                        <div>{{ $t('setup653') }}></div>
                    </div>
                    <!-- <div>
                        <div>
                            $0
                        </div>
                        <div>取款</div>
                    </div>
                    <div>
                        <div>
                            $0
                        </div>
                        <div>赚取</div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="phone-box">
            <div class="header">
                <div>{{ $t('setup640') }}</div>
            </div>
            <div class="faq">
                <div class="item">
                    <div class="item-q" @click="faqIndex = 1">
                        <img src="../../../assets/images/faq.png" alt="" srcset="">
                        <div>{{ $t('setup641') }}</div>
                        <svg-icon icon-class="Down" :class="faqIndex == 1 ? 'right' : 'down'" />
                    </div>
                    <div class="item-a" v-show="faqIndex == 1">{{ $t('setup642') }}</div>
                </div>
                <div class="item">
                    <div class="item-q" @click="faqIndex = 2"> <img src="../../../assets/images/faq.png" alt=""
                            srcset="">
                        <div>{{ $t('setup643') }}</div><svg-icon icon-class="Down"
                            :class="faqIndex == 2 ? 'right' : 'down'" />
                    </div>
                    <div class="item-a" v-show="faqIndex == 2">{{ $t('setup644') }}{{ data.info.ratio }}%。{{ $t('setup667')  }}${{ data.info.reg_reward }}</div>
                </div>
                <div class="item">
                    <div class="item-q" @click="faqIndex = 3"> <img src="../../../assets/images/faq.png" alt=""
                            srcset="">
                        <div>{{ $t('setup645') }}</div><svg-icon icon-class="Down"
                            :class="faqIndex == 3 ? 'right' : 'down'" />
                    </div>
                    <div class="item-a" v-show="faqIndex == 3">{{ $t('setup646') }}</div>
                </div>
            </div>
        </div>

    </div>
    <el-dialog v-if="isMobile == false" v-model="dialogVisible" :title="'邀请用户'" width="50vw"
        :before-close="handleClose">
        <!-- 
        <div class="invited-banner">
            <div>
                <div>{{ data.info.member_count }}</div>
                <div>已邀请</div>
            </div>
            <div>
                <div>0</div>
                <div>已激活</div>
            </div>
        </div> -->
        <div class="pc">

            <div class="list">
                <el-table :data="orderList" style="width: 100%" :header-row-style="rowbackground"
                    :header-cell-style="customheaderrow">
                    <el-table-column prop="nick_name" :label="t('cart38')" show-overflow-tooltip />
                    <el-table-column prop="created_at" :label="t('setup647')" show-overflow-tooltip>
                        <template #default="scope">
                            {{ formatToLocalTime(ipTime, scope.row.created_at * 1000) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="order_credit" :label="t('setup648')">
                        <template #default="scope">
                            $0
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" :label="t('setup649')">
                        <template #default="scope">
                            {{ fomartState(scope.row.status) }}
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="page">
                    <el-pagination :total="data.total" @current-change="pageChange" :current-page="data.MemberFrom.page"
                        :page-size="data.MemberFrom.page_size" background layout="prev, pager, next" />
                </div>
            </div>
        </div>
    </el-dialog>
    <el-drawer v-else v-model="dialogVisible" :title="'邀请用户'" class="phone" show-close :with-header="true"
        direction="btt" :before-close="handleClose" size="80%">
        <!-- <div class="invited-banner">
            <div>
                <div>0</div>
                <div>已邀请</div>
            </div>
            <div>
                <div>0</div>
                <div>已激活</div>
            </div>
        </div> -->
        <div class="phone">

            <div class="list">
                <el-table :data="orderList" style="width: 100%" :header-row-style="rowbackground"
                    :header-cell-style="customheaderrow">
                    <el-table-column prop="nick_name" :label="t('cart38')" show-overflow-tooltip />
                    <el-table-column prop="created_at" :label="t('setup647')" show-overflow-tooltip>
                        <template #default="scope">
                            {{ formatToLocalTime(ipTime, scope.row.created_at*1000) }}
                        </template>
                    </el-table-column>
                 
                </el-table>
                <div class="page">
                    <el-pagination :total="data.total" @current-change="pageChange" :current-page="data.MemberFrom.page"
                        :page-size="data.MemberFrom.page_size" background layout="prev, pager, next" />
                </div>
            </div>
        </div>
    </el-drawer>
    <!-- <topUpView v-if="dialogVisible" @handleClose="handleClose" :model="dialogVisible" @getList="getList"></topUpView> -->
    <Prompt v-if="PromptModel" :model="PromptModel" :id="orderSn" @Close="Close"></Prompt>

</template>

<style scoped lang="scss">
// :deep(.custom-header-row) {
//     background-color: #F3F6F8 ;
//     // border-radius: 8px 8px 0px 0px;
// }

.phone {
    display: none;
}

.pc {
    display: block;
}

.dialog {
    width: 500px;
}

.walletPage {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;

    .banner {
        width: 100%;
        height: auto;
        margin-right: 8px;
        border-radius: 15px;
    }

    .step {
        width: 80%;
        margin: 20px auto;
        display: flex;
        align-items: center;

        .line {
            flex: 1;
            height: 0;
            border-bottom: 1px dashed #c92910;
        }

        .icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #fcf4f2;
            color: #c92910;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .icon-text {
                width: max-content;
                position: absolute;
                top: 20px;
                color: #acacac;
            }
        }
    }

    .share-input {
        width: 80%;
        margin: 40px auto 0px;
        height: 40px;
        display: flex;
        align-items: center;
        border: 1px solid #dbdbe2;
        border-radius: 20px;
        padding: 0 20px;
        position: relative;
        color: #c4c3c4;
        background-color: #f9f9fb;

        .copy-icon {
            position: absolute;
            height: 40px;
            line-height: 40px;
            padding: 0 40px;
            right: 0;
            top: 0;
            background-color: #b63417;
            color: #fff;
            border-radius: 20px;
            cursor: pointer;
        }
    }

    .share-tip {
        width: 80%;
        margin: 6px auto 28px;
        color: #c27d37;
        font-size: 12px;
    }

    .dividing-line {
        height: 0;
        width: 100%;
        border-bottom: 1px solid #eeeeee;
    }

    // padding: 0 20px;

    .header {
        padding: 31px 20px 20px 0;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #11192D;
        line-height: 18px;
        text-align: left;
        font-style: normal;

    }

    .amount-info {
        background: #fcf4f2;
        padding: 24px 16px;
        border-radius: 8px;
        display: flex;
        width: 100%;
        align-items: center;

        .info-l {
            width: 40%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 8px;
            font-size: 14px;
            line-height: 1;
            color: #acacac;

            >div:first-child {
                font-weight: 700;
                font-size: 24px;
                color: #262626;
            }

            >div:last-child {
                display: flex;
                justify-content: space-around;

                .btn {
                    // flex: 1;
                    // width: 100%;
                    // height: 40px;
                    // border-radius: 20px;
                    border: none;
                }
            }
        }

        .info-r {
            width: 60%;
            height: 100%;

            >div {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-around;
                border-radius: 8px;
                background-color: #fff;
                color: #262626;
                padding: 20px 0;
                box-sizing: border-box;

                >div {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-around;

                }
            }
        }
    }

    .faq {
        width: 100%;
        border: 1px solid #eee;
        border-radius: 8px;
        padding: 0 16px;

        .item {
            border-bottom: 1px solid #eee;

            .item-q {
                padding: 16px 0;
                width: 100%;
                font-size: 14px;
                display: flex;
                align-items: center;
                position: relative;

                .down,
                .right {
                    position: absolute;
                    top: 19px;
                    right: 0;
                    transform: rotate(0);
                    transition: all 0.5s;
                }

                .right {
                    transform: rotate(180deg);
                }

                >img {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }
            }

            .item-a {
                padding-bottom: 16px;
                font-size: 12px;
            }
        }

        .item:last-child {
            border: none;
        }
    }

}

.page {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
}

.invited-banner {
    width: 100%;
    height: 118px;
    background-image: url('@/assets/images/invitedbanner.png');
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;

    >div {
        width: 50%;
        color: #fff;
        font-size: 24px;
        text-align: center;

        >div:last-child {
            margin-top: 10px;
            font-size: 14px;
        }
    }
}

@media (max-width: 768px) {
    .pc {
        display: none !important;
    }

    .phone {
        display: flex;
        font-size: 14px;

        .list {
            width: 100%;
        }
    }


    .invited-banner {
        height: 60px;
        margin-bottom: 5px;

        >div {
            font-size: 18px;

            >div:last-child {
                margin-top: 5px;
                font-size: 12px;
            }
        }
    }

    .walletPage {
        height: auto;
        margin-top: 25px;
        // padding: 2px 10px 0 10px;
        padding: 2px 0 40px;
        background-color: #F8F8F8;

        .banner {
            height: 170px;
            margin-right: 0;
            object-fit: cover;
            border-radius: 0;

        }

        .step {
            padding: 0 10px;

            .line {}

            .icon {

                .icon-text {
                    max-width: 30vw;
                    color: #666;
                }
            }
        }

        .phone-share {
            width: calc(100% - 20px);
            margin: 70px 10px 0px;
            border-radius: 20px;
            background-color: #fff;
        }

        .phone-box {
            width: calc(100% - 20px);
            margin: 10px 10px 0px;
            border-radius: 20px;
            background-color: #fff;

            .faq {
                width: 100%;
                border: none;
                padding: 0 10px;

                .item {
                    border-bottom: 1px solid #eee;

                    .item-q {


                        >img {}
                    }

                    .item-a {}
                }

                .item:last-child {}
            }
        }

        .share-input {
            width: 100%;
            margin: 0;
            padding: 10px;
            height: 100px;
            display: block;
            background-color: #fff;
            border: none;
            color: #c4c3c4;

            .url {
                color: #666;
                background-color: #f3f3f3;
                border-radius: 10px;
                white-space: nowrap;
                height: 40px;
                line-height: 40px;
                padding: 0 10px;
                font-size: 12px;
                overflow: hidden;
                /* 隐藏超出部分 */
                white-space: nowrap;
                /* 保持文案在一行显示 */
                text-overflow: ellipsis;
                /* 显示省略号 */
            }

            .copy-icon {
                position: relative;
                height: 40px;
                line-height: 40px;
                padding: 0 0;
                margin-top: 10px;
                text-align: center;
            }
        }

        .share-tip {
            width: 100%;
            color: #666;
            padding: 0 10px 10px;
            font-size: 12px;
            margin-bottom: 0;
        }

        .amount-info {
            background: #fff;
            width: calc(100% - 20px);
            margin: 10px 10px;
            border-radius: 20px;
            padding: 20px 10px 0;
            display: block;

            .info-l {
                width: 100%;


                >div:last-child {
                    .btn {
                        flex: 1;
                        width: 100%;
                        height: 40px;
                        border-radius: 20px;
                        // border: none;
                    }

                }
            }

            .info-r {
                margin-top: 20px;
                border-top: 1px solid #eee;
                width: 100%;

                >div {
                    width: 100%;
                    height: 100%;
                    padding: 20px 0;

                    >div {
                        width: 30%;

                        >div:last-child {
                            color: #666;
                            margin-top: 5px;
                        }

                        >div:first-child {
                            font-size: 16px;
                            font-weight: 600;
                        }

                    }
                }
            }
        }

        // background-color: #F8F8F8;
        .header {
            height: 46px;
            line-height: 46px;
            padding: 10px 10px 0;
        }


    }

    .dialog-footer {
        >div {
            width: 100%;
            height: 40px;
            background: #ED4D34;
            border-radius: 20px;
            font-family: 'PingFangSC';
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: center;
            font-style: normal;
        }
    }


    :deep(.item .el-input--suffix) {
        height: 38px;
    }

    :deep(.el-drawer__title) {
        font-family: 'PingFangSC';
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
    }
}
</style>